import { render, staticRenderFns } from "./userCard.vue?vue&type=template&id=7f4ad02c&scoped=true"
import script from "./userCard.vue?vue&type=script&lang=js"
export * from "./userCard.vue?vue&type=script&lang=js"
import style0 from "./userCard.vue?vue&type=style&index=0&id=7f4ad02c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4ad02c",
  null
  
)

export default component.exports